import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '@shared/ui-components/button/button.component';
import { startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ac-energy-rehabilitation-selection',
  standalone: true,
  imports: [TranslateModule, MatRadioGroup, MatRadioButton, ReactiveFormsModule, ButtonComponent, AsyncPipe],
  template: `
    <p class="title-m text-secondary-dark">{{ 'ENERGY_REHABILITATION_SELECTION.TITLE' | translate }}</p>
    <div class="mt-2 s:mt-3"></div>
    <mat-radio-group [formControl]="_optionFormControl">
      <mat-radio-button class="mr-2" value="electricity" [disableRipple]="true">
        {{ 'ENERGY_REHABILITATION_SELECTION.OPTIONS.ELECTRICITY_SUPPLY' | translate }}
      </mat-radio-button>
      <mat-radio-button class="mr-2" value="rehabilitation" [disableRipple]="true">
        {{ 'ENERGY_REHABILITATION_SELECTION.OPTIONS.ENERGY_REHABILITATION' | translate }}
      </mat-radio-button>
    </mat-radio-group>
    <div class="mt-3 flex flex-col s:flex-row s:justify-end">
      <button primary-button [disabled]="_notValid$ | async" (click)="_submit()" (keydown.space)="_submit()" (keydown.enter)="_submit()">
        {{ 'GENERAL.ENTER' | translate }}
      </button>
    </div>
  `,
  styles: `
    @use 'functions';
    @use 'mixins/breakpoints';
    :host {
      display: block;
      padding: functions.spacing(2);
      @include breakpoints.mediaBreakpoint('s') {
        padding: functions.spacing(5);
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnergyRehabilitationSelectionDialog {
  protected readonly _optionFormControl;
  protected readonly _notValid$;
  constructor(
    private readonly _dialogRef: MatDialogRef<EnergyRehabilitationSelectionDialog>,
    @Inject(MAT_DIALOG_DATA)
    private readonly _data: {
      informacionComercializadora: boolean;
      informacionRehabilitacionEnergetica: boolean;
    }
  ) {
    this._optionFormControl = new FormControl<string>('electricity', {
      nonNullable: true,
      validators: Validators.required,
    });

    this._notValid$ = this._optionFormControl.statusChanges.pipe(
      startWith(this._optionFormControl.status),
      map((status) => status !== 'VALID')
    );
  }

  protected _submit(): void {
    if (this._optionFormControl.valid) {
      this._dialogRef.close(this._optionFormControl.value);
    }
  }
}
